import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Flame, Star } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Compact points + streak pill shown in the header for logged-in users.
const PointsWidget = () => {
  const { getAuthHeader, user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!user) return;
    axios
      .get(`${API}/user/stats`, { headers: getAuthHeader() })
      .then((res) => setStats(res.data))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  if (!user || !stats) return null;

  return (
    <div
      data-testid="points-widget"
      className="hidden md:flex items-center gap-2 px-3 py-1.5 rounded-full border-2 border-black dark:border-white bg-[#FFE66D] text-black font-bold text-sm hard-shadow-hover"
      title="Your points and daily streak"
    >
      <span className="flex items-center gap-1" data-testid="points-widget-points">
        <Star className="w-4 h-4 fill-black" strokeWidth={2.5} />
        {stats.points}
      </span>
      <span className="w-px h-4 bg-black/30" />
      <span className="flex items-center gap-1 text-[#FF6B6B]" data-testid="points-widget-streak">
        <Flame className="w-4 h-4 fill-[#FF6B6B]" strokeWidth={2.5} />
        {stats.streak_days}
      </span>
    </div>
  );
};

export default PointsWidget;
